<script>
import { abbreviateStockTypeUnit, unitToDisplayText } from '@/layer/filters/units';

export default {
  filters: {
    abbreviateStockTypeUnit,
    unitToDisplayText,
  },

  props: {
    item: { type: Object, required: true },
    disabled: { type: Boolean, required: true },
    boxesAndExtraFromItem: { type: Function, required: true },
    packedBoxesAndExtraFromItem: { type: Function, required: true },
  },

  computed: {
    boxesQuantity() { return this.boxesAndExtraFromItem(this.item).boxes },
    extraQuantity() { return this.boxesAndExtraFromItem(this.item).extra },

    hasBoxes() { return this.boxesQuantity > 0 },
    hasExtra() { return this.extraQuantity > 0 },

    packedBoxesQuantity: {
      get() { return this.packedBoxesAndExtraFromItem(this.item).boxes },
      set(value) { this.packedBoxesAndExtraFromItem(this.item).boxes = value; },
    },

    packedExtraQuantity: {
      get() { return this.packedBoxesAndExtraFromItem(this.item).extra },
      set(value) { this.packedBoxesAndExtraFromItem(this.item).extra = value; },
    },
  },

  methods: {
    backgroundForQuantityDifference(packed, requested) {
      if (packed === requested) return 'bg-success text-light';
      if (packed < requested) return 'bg-danger text-light';
      else return 'bg-dark text-light';
    },
  },
}
</script>

<template>
  <div>
    <strong> {{item.base_type.type}} {{item.base_type.unit | unitToDisplayText}} </strong>

    <div v-if="hasBoxes" class="d-flex align-items-center mt-2">
      <small style="width:40px;"> {{boxesQuantity}} B </small>

      <b-input-group size="sm" append="B">
        <b-form-input v-model.number="packedBoxesQuantity" type="number" :disabled="disabled" />
        <b-input-group-text slot="prepend" :class="[backgroundForQuantityDifference(packedBoxesQuantity, boxesQuantity)]"> packed </b-input-group-text>
      </b-input-group>
    </div>

    <div v-if="hasExtra" class="d-flex align-items-center mt-2">
      <small style="width:40px;"> {{extraQuantity}} {{item.base_type.unit | abbreviateStockTypeUnit}} </small>

      <b-input-group size="sm" :append="item.base_type.unit | abbreviateStockTypeUnit">
        <b-form-input v-model.number="packedExtraQuantity" type="number" :disabled="disabled" />
        <b-input-group-text slot="prepend" :class="[backgroundForQuantityDifference(packedExtraQuantity, extraQuantity)]"> packed </b-input-group-text>
      </b-input-group>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// src/layer/components/EggOrderItemEditPackedRow.vue